import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminErrorLogsPage, type AdminErrorLogsPageProps } from '../ui/admin/AdminErrorLogsPage';

export function AdminErrorLogsPageContainer(props: AdminErrorLogsPageProps) {
  return <AdminErrorLogsPage {...props} />;
}

export function mountAdminErrorLogsPage(
  container: HTMLElement,
  props: AdminErrorLogsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminErrorLogsPageContainer {...props} />);
  return root;
}

export default AdminErrorLogsPageContainer;
